/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_TOTAL_CO2_EMISSIONS_RESPONSE = {
	title: "Total CO2e emissions by Resource: Timeseries",
	lineSeries: [
		{
			name: "Total CO2",
			linePoints: [
				{ name: "2025-01T00:00:00Z", value: 30, unit: "kgCO2" },
				{ name: "2025-02T00:00:00Z", value: 25, unit: "kgCO2" },
				{ name: "2025-03T00:00:00Z", value: 40, unit: "kgCO2" },
				{ name: "2025-04T00:00:00Z", value: 45, unit: "kgCO2" },
				{ name: "2025-05T00:00:00Z", value: 35, unit: "kgCO2" },
				{ name: "2025-06T00:00:00Z", value: 50, unit: "kgCO2" },
				{ name: "2025-07T00:00:00Z", value: 38, unit: "kgCO2" },
				{ name: "2025-08T00:00:00Z", value: 42, unit: "kgCO2" },
				{ name: "2025-09T00:00:00Z", value: 30, unit: "kgCO2" },
				{ name: "2025-10T00:00:00Z", value: 45, unit: "kgCO2" },
				{ name: "2025-11T00:00:00Z", value: 50, unit: "kgCO2" },
				{ name: "2025-12T00:00:00Z", value: 55, unit: "kgCO2" }
			]
		},
		{
			name: "GPU",
			linePoints: [
				{ name: "2025-01T00:00:00Z", value: 10, unit: "kgCO2" },
				{ name: "2025-02T00:00:00Z", value: 15, unit: "kgCO2" },
				{ name: "2025-03T00:00:00Z", value: 20, unit: "kgCO2" },
				{ name: "2025-04T00:00:00Z", value: 18, unit: "kgCO2" },
				{ name: "2025-05T00:00:00Z", value: 25, unit: "kgCO2" },
				{ name: "2025-06T00:00:00Z", value: 30, unit: "kgCO2" },
				{ name: "2025-07T00:00:00Z", value: 35, unit: "kgCO2" },
				{ name: "2025-08T00:00:00Z", value: 28, unit: "kgCO2" },
				{ name: "2025-09T00:00:00Z", value: 22, unit: "kgCO2" },
				{ name: "2025-10T00:00:00Z", value: 30, unit: "kgCO2" },
				{ name: "2025-11T00:00:00Z", value: 28, unit: "kgCO2" },
				{ name: "2025-12T00:00:00Z", value: 32, unit: "kgCO2" }
			]
		},
		{
			name: "CPU",
			linePoints: [
				{ name: "2025-01T00:00:00Z", value: 5, unit: "kgCO2" },
				{ name: "2025-02T00:00:00Z", value: 8, unit: "kgCO2" },
				{ name: "2025-03T00:00:00Z", value: 12, unit: "kgCO2" },
				{ name: "2025-04T00:00:00Z", value: 14, unit: "kgCO2" },
				{ name: "2025-05T00:00:00Z", value: 10, unit: "kgCO2" },
				{ name: "2025-06T00:00:00Z", value: 15, unit: "kgCO2" },
				{ name: "2025-07T00:00:00Z", value: 18, unit: "kgCO2" },
				{ name: "2025-08T00:00:00Z", value: 12, unit: "kgCO2" },
				{ name: "2025-09T00:00:00Z", value: 10, unit: "kgCO2" },
				{ name: "2025-10T00:00:00Z", value: 12, unit: "kgCO2" },
				{ name: "2025-11T00:00:00Z", value: 14, unit: "kgCO2" },
				{ name: "2025-12T00:00:00Z", value: 16, unit: "kgCO2" }
			]
		},
		{
			name: "Memory",
			linePoints: [
				{ name: "2025-01T00:00:00Z", value: 8, unit: "kgCO2" },
				{ name: "2025-02T00:00:00Z", value: 10, unit: "kgCO2" },
				{ name: "2025-03T00:00:00Z", value: 15, unit: "kgCO2" },
				{ name: "2025-04T00:00:00Z", value: 18, unit: "kgCO2" },
				{ name: "2025-05T00:00:00Z", value: 14, unit: "kgCO2" },
				{ name: "2025-06T00:00:00Z", value: 20, unit: "kgCO2" },
				{ name: "2025-07T00:00:00Z", value: 22, unit: "kgCO2" },
				{ name: "2025-08T00:00:00Z", value: 18, unit: "kgCO2" },
				{ name: "2025-09T00:00:00Z", value: 16, unit: "kgCO2" },
				{ name: "2025-10T00:00:00Z", value: 18, unit: "kgCO2" },
				{ name: "2025-11T00:00:00Z", value: 20, unit: "kgCO2" },
				{ name: "2025-12T00:00:00Z", value: 22, unit: "kgCO2" }
			]
		},
		{
			name: "Storage",
			linePoints: [
				{ name: "2025-01T00:00:00Z", value: 2, unit: "kgCO2" },
				{ name: "2025-02T00:00:00Z", value: 4, unit: "kgCO2" },
				{ name: "2025-03T00:00:00Z", value: 5, unit: "kgCO2" },
				{ name: "2025-04T00:00:00Z", value: 6, unit: "kgCO2" },
				{ name: "2025-05T00:00:00Z", value: 8, unit: "kgCO2" },
				{ name: "2025-06T00:00:00Z", value: 10, unit: "kgCO2" },
				{ name: "2025-07T00:00:00Z", value: 12, unit: "kgCO2" },
				{ name: "2025-08T00:00:00Z", value: 10, unit: "kgCO2" },
				{ name: "2025-09T00:00:00Z", value: 8, unit: "kgCO2" },
				{ name: "2025-10T00:00:00Z", value: 10, unit: "kgCO2" },
				{ name: "2025-11T00:00:00Z", value: 12, unit: "kgCO2" },
				{ name: "2025-12T00:00:00Z", value: 14, unit: "kgCO2" }
			]
		}
	]
};

export const GET_TOP_10_EMISSIONS_RESPONSE = {
	title: "Embodied emissions by Apps",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{
					name: "GCP Application",
					value: 85,
					unit: "kgCO2"
				},
				{
					name: "AWS German Cluster",
					value: 75,
					unit: "kgCO2"
				},
				{
					name: "Azure Spain Platform",
					value: 65,
					unit: "kgCO2"
				},
				{
					name: "Dummy eCommerce",
					value: 60,
					unit: "kgCO2"
				},
				{
					name: "Fatturazione",
					value: 52,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 40,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 35,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 30,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 25,
					unit: "kgCO2",
					tenantRegion: true
				}
			]
		}
	]
};

export const GET_RESOURCES_EMISSIONS_RESPONSE = {
	title: "Total CO2e emissions by Resource(%)",
	PieChartSlice: [
		{
			name: "GPU",
			value: 45.28,
			unit: "%"
		},
		{
			name: "CPU",
			value: 25.0,
			unit: "%"
		},
		{
			name: "Memory",
			value: 20.0,
			unit: "%"
		},
		{
			name: "Storage",
			value: 9.72,
			unit: "%"
		}
	]
};
